import { downloadBlob } from "@shared/api/downloadBlob";
import { formatDateForAPI } from "@utils/datetime";

export type ReportType = "business" | "delay";

export const downloadReport =
  (fetch: Client.HttpClient, reportType: ReportType) =>
  async (
    startDate: Date,
    endDate: Date,
    processDefinitionIds: number[] = []
  ) => {
    const params = new URLSearchParams({
      startDate: formatDateForAPI(startDate),
      endDate: formatDateForAPI(endDate),
    });

    processDefinitionIds.forEach((id) => {
      params.append("processDefinitionId", String(id));
    });

    const blob = await fetch.get<Blob>(
      `/api/reports/${reportType}?${params.toString()}`
    );

    downloadBlob(blob, `sentinel-${reportType}-${Date.now()}.csv`);
  };

export const getReport = (fetch: Client.HttpClient) =>
  downloadReport(fetch, "business");

export const getDelayReport = (fetch: Client.HttpClient) =>
  downloadReport(fetch, "delay");
